// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ccef2066","453":"f28307b1","455":"873b4874"}[chunkId] + ".chunk.js";
};